import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, formatINR } from "@/lib/api";
import { CheckCircle2 } from "lucide-react";

export default function OrderConfirmation() {
  const { id } = useParams();
  const [o, setO] = useState(null);
  useEffect(() => { api.get(`/orders/${id}`).then(r => setO(r.data)); }, [id]);
  if (!o) return <div className="max-w-3xl mx-auto py-32 text-center text-[#C2B29F]">Loading…</div>;

  return (
    <div data-testid="order-confirmation" className="max-w-3xl mx-auto px-6 py-16">
      <div className="text-center">
        <CheckCircle2 size={56} className="text-[#D4AF37] mx-auto"/>
        <div className="eyebrow mt-6">Your Order Is Confirmed</div>
        <h1 className="font-serif-luxe text-4xl sm:text-5xl text-[#FAF8F5] mt-3">Thank you, {o.customer_name.split(" ")[0]}</h1>
        <p className="text-[#C2B29F] mt-4 text-sm">Order <span className="text-[#D4AF37]">#{o.id.slice(0, 8).toUpperCase()}</span> has been placed with an aura. A confirmation has been emailed to {o.email}.</p>
      </div>

      <div className="mt-12 bg-[#1C130E] border border-[#D4AF37]/20 p-8">
        <div className="eyebrow mb-4">Items</div>
        <div className="space-y-4">
          {o.items.map((i, idx) => (
            <div key={idx} className="flex gap-4">
              <img src={i.image} alt="" className="w-16 h-16 object-cover"/>
              <div className="flex-1">
                <div className="text-[#FAF8F5] text-sm">{i.name}</div>
                <div className="text-xs text-[#C2B29F]">Qty {i.quantity}</div>
              </div>
              <div className="text-[#D4AF37]">{formatINR(i.price * i.quantity)}</div>
            </div>
          ))}
        </div>
        <div className="border-t border-[#D4AF37]/15 mt-6 pt-4 flex justify-between text-lg">
          <span className="text-[#FAF8F5]">Total</span>
          <span className="font-serif-luxe text-[#D4AF37]">{formatINR(o.total)}</span>
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <div className="eyebrow">Shipping To</div>
          <div className="text-sm text-[#FAF8F5] mt-2">{o.customer_name}<br/>{o.address}<br/>{o.city}, {o.state} {o.pincode}<br/>{o.phone}</div>
        </div>
        <div>
          <div className="eyebrow">Estimated Delivery</div>
          <div className="text-sm text-[#FAF8F5] mt-2">3–7 business days · Complimentary insured shipping</div>
        </div>
      </div>

      <div className="text-center mt-12">
        <Link to="/shop" className="btn-outline-gold">Continue Shopping</Link>
      </div>
    </div>
  );
}
